import { render, staticRenderFns } from "./ValidableFormGroup.vue?vue&type=template&id=03628cb4&lang=pug"
import script from "./ValidableFormGroup.vue?vue&type=script&lang=js"
export * from "./ValidableFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports